var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
import { fade } from '../styles/color-manipulator';
var pulsingDotComponentName = 'QuantumPulsingDot';
var BoxShadowCustomProperty = "--".concat(pulsingDotComponentName.toLowerCase(), "-box-shadow-color");
var BoxShadowCustomPropertyFaded = "--".concat(pulsingDotComponentName.toLowerCase(), "-box-shadow-color-faded");
var Root = styled('div', { name: pulsingDotComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    var getCustomPropertiesForColor = function (colorValue) {
        var _a;
        return _a = {},
            _a[BoxShadowCustomProperty] = colorValue,
            _a[BoxShadowCustomPropertyFaded] = fade(colorValue, 0),
            _a;
    };
    var defaultPulse = __assign({ backgroundColor: theme.tokens.color_bg_state_neutral }, getCustomPropertiesForColor(theme.tokens.color_bg_state_neutral_subtle));
    var primaryPulse = __assign({ backgroundColor: theme.tokens.color_bg_brand_primary }, getCustomPropertiesForColor(theme.tokens.color_bg_brand_primary_subtle));
    var dangerPulse = __assign({ backgroundColor: theme.tokens.color_bg_state_danger }, getCustomPropertiesForColor(theme.tokens.color_bg_state_danger_subtle));
    var infoPulse = __assign({ backgroundColor: theme.tokens.color_bg_state_info }, getCustomPropertiesForColor(theme.tokens.color_bg_state_info_subtle));
    var warningPulse = __assign({ backgroundColor: theme.tokens.color_bg_state_caution }, getCustomPropertiesForColor(theme.tokens.color_bg_state_caution_subtle));
    var successPulse = __assign({ backgroundColor: theme.tokens.color_bg_state_success }, getCustomPropertiesForColor(theme.tokens.color_bg_state_success_subtle));
    var getPulseColor = function (pulseColor) {
        switch (pulseColor) {
            case 'primary':
                return primaryPulse;
            case 'danger':
                return dangerPulse;
            case 'warning':
                return warningPulse;
            case 'success':
                return successPulse;
            case 'info':
                return infoPulse;
            default:
                return defaultPulse;
        }
    };
    return __assign({ '@keyframes pulse': {
            '0%': {
                transform: 'scale(0.75)',
                boxShadow: "0 0 0 0 var(".concat(BoxShadowCustomProperty, ")"),
            },
            '70%': {
                transform: 'scale(1)',
                boxShadow: "0 0 0 8px var(".concat(BoxShadowCustomPropertyFaded, ")"),
            },
            '100%': {
                transform: 'scale(0.75)',
                boxShadow: "0 0 0 0 var(".concat(BoxShadowCustomPropertyFaded, ")"),
            },
        }, height: theme.typography.pxToRem(8), width: theme.typography.pxToRem(8), borderRadius: '50%', display: 'inline-block', animation: 'pulse 2s infinite' }, getPulseColor(ownerState.color));
});
export var PulsingDot = React.forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? 'default' : _a, rootProps = __rest(props, ["color"]);
    return React.createElement(Root, __assign({ ref: ref, ownerState: { color: color } }, rootProps));
});
